var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.changeTitle()}}),_c('router-view'),_c('loading',{attrs:{"active":_vm.cs.isLoading,"can-cancel":false,"is-full-page":true,"loader":"bars","width":70,"height":70,"color":_vm.$theme.primary},on:{"update:active":function($event){return _vm.$set(_vm.cs, "isLoading", $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }